import React, { useEffect, useState } from 'react';
import { getSiteSettings } from '../../api/siteSettings';
import '../../styles/components/_footer.scss';
import Icon from '../Icons/Icon';
import { FaYoutube, FaTwitter, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await getSiteSettings();
        if (response.isSuccess) {
          // API'den gelen verileri doğrudan kullanıyoruz
          setSiteSettings(response.data);
        }
      } catch (error) {
        console.error('Site ayarları yüklenirken hata oluştu:', error);
      }
    };

    fetchSiteSettings();
  }, []);

  return (
    <div className='footer_section'>
      <div className="mayor-box xs-mt-5 padding-20">
        <div className="mayor-box-left">
          {/* <div className="mayor-box-left-image">
            <img src="/assets/images/baskan-gorev.png" alt="İskenderun Belediye Başkanı Mehmet Dönmez" />
          </div> */}
        </div>
        <div className="mayor-box-right">
          <h4>Mehmet Dönmez</h4>
          <p>İskenderun Belediye Başkanı</p>

          <div className="mayor-box-right-social">
            {siteSettings?.youtubeUrl && (
              <a href={siteSettings.youtubeUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaYoutube />
              </a>
            )}
            {siteSettings?.twitterUrl && (
              <a href={siteSettings.twitterUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaTwitter />
              </a>
            )}
            {siteSettings?.facebookUrl && (
              <a href={siteSettings.facebookUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaFacebook />
              </a>
            )}
            {siteSettings?.instagramUrl && (
              <a href={siteSettings.instagramUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaInstagram />
              </a>
            )}
          </div>
        </div>
      </div>
      <footer className="footer lg-mt-5">
        <div className="footer-container">
          <div className="row">
            <div className="col-md-4">
              <div className="footer-widget">
                <div className="footer-widget-left">
                  <div className="form-icon">
                    <Icon icon="forms" size="69" />
                  </div>
                </div>
                <div className="footer-widget-right">
                  <h4>Formlar</h4>
                  <ul className="footer-widget-menu">
                    <li><a href="/iletisim">Öneri ve Şikayetleriniz</a></li>
                    <li><a href="/bilgi-edinme-hakki">Bilgi Edinme</a></li>
                    <li><a href="/iletisim">Başkana Mesaj</a></li>
                    <li><a href="/kvkk-basvuru">KVKK Başvuru Formu</a></li>
                    <li><a href="/gizlilik-politikasi">Gizlilik Politikası</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footer-widget">
                <div className="footer-widget-left">
                  <div className="form-icon">
                    <Icon icon="kurumsal" size="69" />
                  </div>
                </div>
                <div className="footer-widget-right">
                  <h4>Kurumsal</h4>
                  <ul className="footer-widget-menu">
                    <li><a href="/faaliyet-raporlari">Faaliyet Raporları</a></li>
                    <li><a href="/meclis-kararlari">Meclis Kararlari</a></li>
                    <li><a href="/baskanla-fotografim">Başkanla Fotoğrafım</a></li>
                    <li><a href="/videolar">Video Galeri</a></li>
                    <li><a href="/haberler">Haber Arşiv</a></li>
                    <li><a href="/ihaleler">İhaleler</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footer-widget">
                <div className="footer-widget-left">
                  <div className="form-icon">
                    <Icon icon="contact" size="69" />
                  </div>
                </div>
                <div className="footer-widget-right">
                  <h4>İletişim</h4>
                  <ul className="footer-widget-menu">
                    <li><a>Faks: 444 1 939</a></li>
                    <li><a href="tel:905305421939">Telefon: 444 19 39</a></li>
                    <li><a href="mailto:belediye@iskenderun.bel.tr">E-Posta: bilgi@iskenderun.bel.tr</a></li>
                    <li><a>Adres: Yenişehir, Mareşal Fevzi Çakmak Cd. No:48, 31200 İskenderun/Hatay</a></li>
                    <li><a href="tel:4441939">Santral: 0326 613 49 90</a></li>
                  </ul>

                  <div className="footer-social">
                    <div className="footer-social-left">
                      {siteSettings?.youtubeUrl && (
                        <a href={siteSettings.youtubeUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
                          <FaYoutube />
                        </a>
                      )}
                      {siteSettings?.twitterUrl && (
                        <a href={siteSettings.twitterUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
                          <FaTwitter />
                        </a>
                      )}
                      {siteSettings?.facebookUrl && (
                        <a href={siteSettings.facebookUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
                          <FaFacebook />
                        </a>
                      )}
                      {siteSettings?.instagramUrl && (
                        <a href={siteSettings.instagramUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
                          <FaInstagram />
                        </a>
                      )}
                      {siteSettings?.linkedinUrl && siteSettings.linkedinUrl.trim() !== '' && (
                        <a href={siteSettings.linkedinUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
                          <FaLinkedin />
                        </a>
                      )}
                    </div>
                    <div className="footer-social-right">
                      <a href="/iletisim" className="contact-us">Bize Ulaşın</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <p>{siteSettings?.copyrightDescription || 'T.C. İskenderun Belediyesi 2024. Her Hakkı Saklıdır.'}</p>
          </div>
        </div>
      </footer>
    </div>

  );
};

export default Footer;
